import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import ObjectListItem from "../components/ObjectListItem"
import { use100vh } from "react-div-100vh"
import SEO from "../components/seo"
import Transition from "../components/Transition"

export default function Objects({
  data: {
    allContentfulObject: { edges },
    allContentfulAbout,
    allContentfulNoPageListItem,
  },
}) {
  const height = use100vh()
  let newArr = edges.concat(allContentfulNoPageListItem.edges)

  // Sort by year (descending order, newest first)
  newArr.sort((a, b) => {
    return (b.node.year || 0) - (a.node.year || 0) // Handles missing years
  })

  let objectList = newArr.map((object, i) => {
    let img = object.node.gallery ? object.node.gallery[0] : false
    let path = object.node.path || false

    return (
      <ObjectListItem
        key={i}
        itemName={object.node.objectName || object.node.name}
        year={object.node.year}
        materials={object.node.materials}
        featuredImg={img}
        path={path}
        wip={object.node.wip}
      />
    )
  })

  return (
    <Transition>
      <SEO title="Overview | Ette" />
      <Layout about={allContentfulAbout}>
        <div
          style={{ height: height, maxHeight: height }}
          className="no-bar overflow-y-scroll flex flex-col"
        >
          <ul className="px-5 py-3 lg:pt-36">{objectList}</ul>
        </div>
      </Layout>
    </Transition>
  )
}

export const pageQuery = graphql`
  query {
    allContentfulObject(sort: { fields: year, order: DESC }) {
      edges {
        node {
          objectName
          year
          materials
          path
          gallery {
            fluid(quality: 50, maxWidth: 700) {
              base64
              srcSet
              aspectRatio
            }
            fixed(height: 700, width: 540) {
              base64
              aspectRatio
              srcSet
            }
          }
          featured
        }
      }
    }
    allContentfulNoPageListItem(sort: { fields: year, order: DESC }) {
      edges {
        node {
          name
          date
          materials
          year
          wip
        }
      }
    }
    allContentfulAbout {
      edges {
        node {
          aboutDescription {
            raw
          }
          pressLinks {
            linkTitle
            link
          }
          socialMediaLinks {
            linkTitle
            link
          }
        }
      }
    }
  }
`
